import type { EndUserStateResponseData } from 'services/api/endUserDashboardApi.data';

function pickFirstNonBlankString(candidates: Array<string | null | undefined>): string | null {
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) {
      return candidate.trim();
    }
  }

  return null;
}

/** Resolves organization display name from GET /eu/{euId}/state payload. */
export const pickEndUserOrgName = (data: EndUserStateResponseData | undefined): string | null => {
  if (!data) {
    return null;
  }

  return pickFirstNonBlankString([data.orgName, data['org-name'], data.org_name]);
};

/** Resolves unit display name from GET /eu/{euId}/state payload. */
export const pickEndUserUnitName = (data: EndUserStateResponseData | undefined): string | null => {
  if (!data) {
    return null;
  }

  return pickFirstNonBlankString([
    data.unitName,
    data['unit-name'],
    data.unit_name,
    data.unit_display_name,
    data['unit-display-name'],
  ]);
};

/** Resolves end-user display name from GET /eu/{euId}/state payload. */
export const pickEndUserDisplayName = (
  data: EndUserStateResponseData | undefined
): string | null => {
  if (!data) {
    return null;
  }

  return pickFirstNonBlankString([
    data.name,
    data.preferredName,
    data.preferred_name,
    data.firstName,
    data.first_name,
  ]);
};

/** Resolves email from GET /eu/{euId}/state payload. */
export const pickEndUserEmail = (data: EndUserStateResponseData | undefined): string | null => {
  if (!data) {
    return null;
  }

  return pickFirstNonBlankString([
    data.email,
    data.personalEmail,
    data.personal_email,
    data['personal-email'],
  ]);
};
